import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentUser } from '../use-get-current-user';

export const useCostCalculatorStatus = () => {
  const { data: currentUser } = useGetCurrentUser();
  const orgId = currentUser?.organization?.id;

  const { data: entitlement, isLoading } =
    projectApi.useGetOrganizationsByOrgIdEntitlementDefnQuery(
      { orgId: orgId ?? 0 },
      { skip: !orgId },
    );

  const isCostCalcEnabled = entitlement?.costCalc?.isEnabled === true;

  return {
    isCostCalcEnabled,
    isLoading,
  };
};
